export default __webpack_public_path__ + "static/media/pr.1a68a301.svg";